// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"76d755f6","952":"88f34391"}[chunkId] + ".chunk.js";
};